import { authHeader } from '../_helpers';
import { apiConstants } from '../_constants'
import Cookies from 'universal-cookie';
import request from 'superagent';
import { alertActions, userActions , fetchingActions } from '../_actions';
import { store } from '../_helpers/store';
import { history , utils } from '../_helpers';
import { showLoading, hideLoading } from 'react-redux-loading-bar';

export const userService = {
    register , login , confirmEmail , resendEmail , getRefreshToken , logout , memberProfile , 
    checkAuth , update , forgetPassword , resetPassword , updateWireInformation , getMemberBanks
};

function login(formBody) {
   return (
        utils.Post(`${apiConstants.ENDPOINT}member/login` , formBody , true)
        .catch(error=> { 
            window.location.reload(); 
        })
   )
}

function register(formBody) {

    return (
        
        utils.Post(`${apiConstants.ENDPOINT}member/register` , formBody , true)
        .then(response=>{

            store.dispatch(
                alertActions.success("Registration successful , please verify your email before login")
            );
            window.location.href = '/login';
        })
        .catch(()=>{
            window.location.reload();
        })
    )
}

function memberProfile(){
    
    let memberId = store.getState().authentication.user.id;

    return (
        utils.Get(`${apiConstants.ENDPOINT}/member/getmemberprofile/${memberId}`)
        .then(response=>response)
    )
}

function getMemberBanks(){
    
    let memberId = store.getState().authentication.user.id;

    return (
        utils.Get(`${apiConstants.ENDPOINT}/member/GetMemberBanks/${memberId}`)
        .then(response=>response)
    )
}

function confirmEmail(email , code){
    
    return (
        utils.Get(`${apiConstants.ENDPOINT}member/confirmemail?email=${email}&code=${code}`, true)
        .then(response=> true)
    )
}

function resendEmail(formBody){
    return (
        utils.Post(`${apiConstants.ENDPOINT}member/resendemail` , formBody , true)
        .then(response=>{

            store.dispatch(
                alertActions.success("Email verification sent , please verify and login again")
            );

            window.location.href = '/login';
        })
        .catch(()=>{
            
            window.location.reload();
        })
    )
}

function forgetPassword(formBody){
    return (
        utils.Post(`${apiConstants.ENDPOINT}member/ForgetPassword` , formBody , true)
        .then(response=>{

            store.dispatch(
                alertActions.success("We have send email to reset password , please check email to reset.")
            );

            window.location.href = '/';
        })
        .catch(()=>{
            
            window.location.reload();
        })
    )
}

function resetPassword(formBody) {

    return (
        
        utils.Post(`${apiConstants.ENDPOINT}member/ResetPassword` , formBody , true)
        .then(response=>{

            store.dispatch(
                alertActions.success("Password reset successful , please login with your new password")
            );
            window.location.href = '/login';
        })
        .catch(()=>{
            window.location.reload();
        })
    )
}

function checkAuth(){

    //rewrite checkAuth to use new request instead of Util GET helper to prevent reload loop 

    store.dispatch(showLoading());

    let authentication = store.getState().authentication;
    let token = authentication ? authentication.user.token : '' ;
    
    return (
        
        request
        .get(`${apiConstants.ENDPOINT}member/checkAuth`)
        .set('Authorization' , `Bearer ${token}`)
        .then(response=> {
            store.dispatch(hideLoading());

            return (response.body);
        })
        .catch( error => {
            store.dispatch(hideLoading());

            //try to refresh token 
            if(error.response){
                const errResponse = error.response; 

                if(error.response.statusCode === 402){
                    const user = JSON.parse(localStorage.getItem('user')); 
                
                    userService.getRefreshToken(user)
                    .then((response)=>{
                        //successfully refresh token 
                        window.location.reload(); 
                    })
                    .catch((error) => {
                        store.dispatch(alertActions.error(errResponse));  //only dispatch token expiry error if failed to refresh

                        window.location.href = '/login' ;
                        //throw error ; 
                    })
                }
            }

        })
    )
}

function getRefreshToken(user){

    var formBody = {
        token : user.token , 
        refreshtoken : user.refreshtoken 
    }
    
    return (
        utils.Post(`${apiConstants.ENDPOINT}member/refreshtoken` , formBody , true)
        .then(response=> {
            if(response){
                //refresh token received , update userlocal storage information 
                //update data 
                user.token = response.token; 
                user.refreshtoken = response.refreshtoken; 
                
                localStorage.setItem("user", JSON.stringify(user));
                
                //update redux user and stop fetching 
                store.dispatch(userActions.refreshToken(user));
            }
        })
        .catch(error => {
            throw error
        })
    )
}

function update(formBody , file){

    store.dispatch(showLoading());

    let token ;
    let authentication = store.getState().authentication;
    token = authentication ? authentication.user.token : '' ;

    let postrequest = request
        .post(`${apiConstants.ENDPOINT}member/MemberUpdate`)
        .set('Authorization' , `Bearer ${token}`);


    utils.toFormFields(formBody).forEach(
        ([field, value]) => value ? postrequest.field(field, value) : null
    );

    if(file){
        postrequest
        .attach('file', file, file.name)
    }

    return (
        postrequest
            .then(response=>{
                store.dispatch(hideLoading());
                
                store.dispatch(
                    alertActions.success("Member profile updated")
                );
                window.location.reload();
            })
            .catch( error => {
                store.dispatch(hideLoading());
                store.dispatch(alertActions.error(error.response));

                window.location.reload();
            })
    )

}

function updateWireInformation(formBody , file){

    store.dispatch(showLoading());

    let token ;
    let authentication = store.getState().authentication;
    token = authentication ? authentication.user.token : '' ;

    let postrequest = request
        .post(`${apiConstants.ENDPOINT}member/MemberUpdateWireInformation`)
        .set('Authorization' , `Bearer ${token}`);


    utils.toFormFields(formBody).forEach(
        ([field, value]) => value ? postrequest.field(field, value) : null
    );

    if(file){
        postrequest
        .attach('file', file, file.name)
    }

    return (
        postrequest
            .then(response=>{
                store.dispatch(hideLoading());
                
                store.dispatch(
                    alertActions.success("Member Wire Information updated")
                );
                window.location.reload();
            })
            .catch( error => {
                store.dispatch(hideLoading());
                store.dispatch(alertActions.error(error.response));

                window.location.reload();
            })
    )

}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');

    window.location.href = "/login";
}


function handleResponse(response) {
    if (!response.ok) { 
        return Promise.reject(response.statusText);
    }
    return response.json();
}



// WEBPACK FOOTER //
// ./src/_services/user.service.js